common = {
  //combine URL function
  //fixes broken images issue when running the VS SQL server locally
  combine: function() {
    var result = "";
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i]) {
        if (!result.length) {
          result = arguments[i];
        } else {
          result += "/" + arguments[i];
        }
      }
    }
    return result.replace(/\\+/g, "/").replace(/([^:])(\/\/)/g, "$1/");
  }
};
String.prototype.endsWith = function(str) {
  return this.match(str + "$") == str;
};
String.IsNullOrEmpty = function(value) {
  var isNullOrEmpty = true;
  if (value) {
    if (typeof value == "string") {
      if (value.length > 0) {
        isNullOrEmpty = false;
      }
    }
  }
  return isNullOrEmpty;
};
String.unEscape = function(value) {
  return value
    .replace(/\\\//g, "/")
    .replace(/\\\"/g, '"')
    .replace(/\\\\/g, "\\")
    .replace(/\\'/g, "'");
};
String.Format = function() {
  var s = arguments[0];
  for (var i = 0; i < arguments.length - 1; i++) {
    var value = arguments[i + 1];
    // support passing arrays instead of strings
    if (typeof value == "object") {
      for (var j = 0; j < value.length; j++) {
        var reg = new RegExp("\\{" + (i + j) + "\\}", "gm");
        s = s.replace(reg, value[j]);
      }
    } else {
      var reg = new RegExp("\\{" + i + "\\}", "gm");
      s = s.replace(reg, value);
    }
  }
  return s;
};
if (!Array.indexOf) {
  Array.indexOf = function(list, obj) {
    var i = 0;
    for (var key in list) {
      if (key == obj) {
        return i;
      }
      i++;
    }
    return -1;
  };
}
// Escapes strings for use in xml attributes or character data.  Enclosing quotes are not added.
function xmlEscape(s) {
  if (s && s.replace) {
    s = s.replace(/&/g, "&amp;");
    s = s.replace(/</g, "&lt;");
    s = s.replace(/\\'/g, "&apos;");
    s = s.replace(/'/g, "&apos;");
    s = s.replace(/"/g, "&quot;");
    s = s.replace(/>/g, "&gt;");
    s = s.replace(/\n/gi, "&#xa;");
    s = s.replace(/\r/gi, "&#xd;");
    s = s.replace(/\t/gi, "&#x9;");
  }
  return s;
}
// escapes the string for use in URLs
function urlEscape(s) {
  return encodeURIComponent(s);
}
function xmlUnescape(s) {
  if (s && s.replace) {
    s = s.replace(/&amp;/g, "&");
    s = s.replace(/&apos;/g, "'");
    s = s.replace(/&quot;/g, '"');
    s = s.replace(/\n/gi, "<BR>");
    s = s.replace(/&#xd;/gi, "<BR>");
  }
  return s;
}
function htmlUnescape(s) {
  if (s && s.replace) {
    s = s.replace(/&amp;/g, "&");
    s = s.replace(/&apos;/g, "'");
    s = s.replace(/&quot;/g, '"');
    s = s.replace(/&lt;/g, "<");
    s = s.replace(/&gt;/g, ">");
    s = s.replace(/\n/gi, "<BR>");
    s = s.replace(/&#xd;/gi, "<BR>");
  }
  if (s && s.indexOf) {
    if (s.indexOf("<") > -1) {
      // Strip escaped <SCRIPT> tags
      var esc = s.toUpperCase().indexOf("<SCRIPT");
      if (esc > -1) {
        var end = s.toUpperCase().indexOf("</SCRIPT", esc);
        if (end > esc) s = s.substr(0, esc) + s.substr(end + 15);
        else s = s.substr(0, esc);
      }
    }
  }
  return s;
}
